import GetAQuote from "./get-a-quote/GetAQuote";

export default function App() {
  return <GetAQuote />;
}
